// extracted by mini-css-extract-plugin
export default {"skillCard":"SkillCard_skillCard__Kue7B","dark":"SkillCard_dark__gPBnZ","light":"SkillCard_light__eHNuf"};